// import Firebase from 'firebase'
import moment from 'moment'
import firedux from '../firedux'

import {
  MESSAGES_ENDPOINT,
  MESSAGE_TYPES,
  MESSAGE_APPROVAL_STATUSES
} from '../../config/constants'

import isUserModerator from '../helpers/is_user_moderator'
import sendMessageNotification from './send_message_notification'
import incrementTotalMessageCount from './increment_total_message_count'
import updateLatestMessageTimes from './update_latest_message_times'

const constructMessageObject = (message, from ,to, type, role, conversationId) => {
  let approvalStatus = null

  if (type === MESSAGE_TYPES.MODERATED_GROUP) {
    if (isUserModerator(role)) approvalStatus = MESSAGE_APPROVAL_STATUSES.APPROVED
    else approvalStatus = MESSAGE_APPROVAL_STATUSES.INITIAL
  }

  return {
    message, from, to, type, approvalStatus,
    conversationId,
    time: moment().valueOf()
    // TODO: figure this out when firebase fixes timing on turkey's side (timezone change :/)
    // time: Firebase.ServerValue.TIMESTAMP
  }
}

const sendNewMessage = (containerId, message, from, to, type, role) => {
  const ENDPOINT = `${MESSAGES_ENDPOINT}/${containerId}`

  return firedux.ref.child(ENDPOINT).push(
    constructMessageObject(message, from, to, type, role, containerId)
  )
}

const notify = (shouldNotify, ref) => {
  if (!shouldNotify) return ref

  return sendMessageNotification(ref)
}

export default (
  message, containerId, from, to,
  shouldNotify = false, type = MESSAGE_TYPES.NORMAL, role) => {

  if (!message || !containerId) return

  return sendNewMessage(containerId, message, from, to, type, role)
    .then(notify.bind(null, shouldNotify))
    .then(updateLatestMessageTimes.bind(null, type, from, to))
    .then(incrementTotalMessageCount.bind(null, containerId))
}



/** WEBPACK FOOTER **
 ** ./modules/shared/data/setters/send_new_message.js
 **/